import React from 'react';

import {
    Button,
    DialogActions,
    DialogTitle,
    TextField,
    withStyles,
    DialogContent,
    List,
    Tabs,
    Tab,
    InputLabel,
    Typography,
    Paper,
} from 'material-ui';
import Select from 'react-select';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import {TabContainer} from '../../../../components/tab/tab_container';
import SimpleEditor from '../../../../components/editor/simple_editor';
import DropzoneImageField from '../../../../components/fields/field_dropzone_image';
import ImageDetailsCropDialog from '../image_details_crop';
import ImageDetailsMetaDialog from '../image_details_meta';
import {b64toBlob, toDataUrl} from '../../../../components/helpers/helpers';
import {styles} from '../../style/staff_section';

class TextColumnsMultipleMediaSectionEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openCropPopup: false,
            openImageMetaPopup: false,
            imageToCrop: null,
            imageToView: null,
            src: null,
            cropResult: null,
            cropRatioId: null,
            thumbCropResult: null,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
        };
    }

    state = {
        index: 0,
    };

    handleTabChange = (event, index) => {
        this.setState({
            index,
        });
    };

    onImageClick = (index, image) => {
        if (image.new) {
            this.updateLocalStateWithImage(
                image,
                index,
                this.props.sectionItems
            );
            let croppedImage = this.props.sectionItems[index].image
                .croppedImage;
            let croppedImageThumb = this.props.sectionItems[index].image
                .croppedImageThumb;
            if (croppedImage) {
                toDataUrl(croppedImage, (cropUrl) => {
                    this.setCroppedImageInState(cropUrl);
                });
            }
            if (croppedImageThumb) {
                toDataUrl(croppedImageThumb, (cropUrl) => {
                    this.setThumbCroppedImageInState(cropUrl);
                });
            }
        } else {
            const {
                title,
                alt,
                name,
                description,
                link,
            } = this.props.sectionItems[index].image;
            this.setState({
                touched: true,
                openCropPopup: true,
                openImageMetaPopup: true,
                imageToCrop: null,
                imageToView: image,
                imageMeta: {
                    title,
                    alt,
                    name,
                    description,
                    link,
                },
            });
        }
    };

    updateLocalStateWithImage(image, index, sectionItems) {
        const {title, alt, name, description, link} = this.props.sectionItems[
            index
        ].image;
        this.setState({
            touched: true,
            openCropPopup: true,
            imageToCrop: image,
            imageMeta: {
                title,
                alt,
                name,
                description,
                link,
            },
        });
    }

    updateState() {
        this.setState({
            openCropPopup: false,
            openImageMetaPopup: false,
            imageToCrop: null,
            src: null,
            cropResult: null,
            cropRatioId: null,
            thumbCropResult: null,
            imageMeta: {
                title: '',
                alt: '',
                name: '',
                description: '',
                link: '',
            },
        });
    }

    setCroppedImageInState(croppedImage) {
        this.setState({
            cropResult: croppedImage,
        });
    }

    setThumbCroppedImageInState(croppedImage) {
        this.setState({
            thumbCropResult: croppedImage,
        });
    }

    render() {
        let {
            title,
            classes,
            open,
            sectionItems,
            onUpdateTitleField,
            onHandleClose,
            onHandleSubmit,
            onCropImage,
            onCropThumbImage,
            onImageMetaUpdate,
            onImageCropRatioUpdate,
            sectionSettings,
            selectedSectionSettings,
            updateSectionSetting,
        } = this.props;

        let {index} = this.state;

        if (!index || typeof index === 'undefined') {
            index = 0;
        }

        let selectedItem = null;
        if (sectionItems) {
            selectedItem = sectionItems[index];
        }

        let selectedItemText = '';
        if (selectedItem && typeof selectedItem.text !== 'undefined') {
            selectedItemText = selectedItem.text;
        }

        let selectedItemImage = null;
        if (selectedItem && typeof selectedItem.image !== 'undefined') {
            selectedItemImage = selectedItem.image;
        }

        const collapsibleSetting = sectionSettings.find(
            (setting) => setting.machine_name === 'section-collapse'
        );
        const selectedCollapseSetting = selectedSectionSettings.find(
            (setting) => setting.machine_name === 'section-collapse'
        );
        const selectedCollapseOptionId = selectedCollapseSetting
            ? selectedCollapseSetting.options[0].id
            : '';

        return (
            <div>
                <EditDialog
                    open={open}
                    classes={{
                        paper: classes.paper,
                        fullWidth: classes.fullWidth,
                    }}
                >
                    <DialogTitle>
                        Edit Text Columns Multiple Media Section
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            margin="dense"
                            id="title"
                            label="Title"
                            onChange={(event) => {
                                onUpdateTitleField(event.target.value);
                            }}
                            fullWidth
                            value={title || ''}
                        />
                        <Tabs
                            value={index}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={this.handleTabChange}
                        >
                            <Tab value={0} label="Text Column 1" />
                            <Tab value={1} label="Text Column 2" />
                            <Tab value={2} label="Text Column 3" />
                            <Tab value={3} label="Text Column 4" />}
                        </Tabs>
                        <TabContainer>
                            <List component="nav">
                                <InputLabel className="simpleEditorLabelPages">
                                    Text
                                </InputLabel>
                                <SimpleEditor
                                    id={index}
                                    initialValue={selectedItemText}
                                    onChange={(htmlBody) => {
                                        this.props.updateItemText(
                                            index,
                                            htmlBody
                                        );
                                    }}
                                />
                                <Typography
                                    variant="subheading"
                                    className={
                                        classes.imageUploadSubheadingText
                                    }
                                >
                                    Text Column Image
                                </Typography>
                                <Paper elevation={1} style={{padding: 10}}>
                                    <DropzoneImageField
                                        multiple={false}
                                        images={selectedItemImage}
                                        onImageDelete={(image) => {
                                            this.props.onDeleteImageField(
                                                index,
                                                image
                                            );
                                        }}
                                        onImageClick={(image) => {
                                            this.onImageClick(index, image);
                                        }}
                                        onImagesDrop={(image) => {
                                            this.props.onUpdateImageField(
                                                index,
                                                image
                                            );
                                        }}
                                    />

                                    {selectedItemImage &&
                                        selectedItemImage.new &&
                                        !selectedItemImage.deleted && (
                                            <h4 className="errMsg">
                                                Once you have selected an Image
                                                please click on it in order to
                                                CROP it. Crop is mandatory!
                                            </h4>
                                        )}
                                </Paper>
                            </List>
                        </TabContainer>

                        {collapsibleSetting && (
                            <Select
                                style={{marginTop: '10px'}}
                                name="collapsible-select"
                                value={selectedCollapseOptionId}
                                onChange={(selectedOption) =>
                                    updateSectionSetting(
                                        selectedOption,
                                        collapsibleSetting
                                    )
                                }
                                options={collapsibleSetting.options}
                                clearable={false}
                                labelKey={'option'}
                                valueKey={'id'}
                                placeholder="Select Collapsible Type"
                                className="React-select-larger-font"
                            />
                        )}
                    </DialogContent>
                    <DialogActions className={classes.dialogActionsBtn}>
                        <Button
                            variant="raised"
                            onClick={(ev) => onHandleClose(ev)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="raised"
                            onClick={(ev) => onHandleSubmit(ev)}
                            color="primary"
                        >
                            Done
                        </Button>
                    </DialogActions>
                </EditDialog>

                <ImageDetailsMetaDialog
                    classes={this.props.classes}
                    open={this.state.openImageMetaPopup}
                    imageMeta={this.state.imageMeta}
                    image={this.state.imageToView}
                    setAltField={(alt) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                alt,
                            },
                        });
                    }}
                    setTitleField={(title) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                title,
                            },
                        });
                    }}
                    setDescriptionField={(description) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                description,
                            },
                        });
                    }}
                    setLinkField={(link) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                link,
                            },
                        });
                    }}
                    setNameField={(name) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                name,
                            },
                        });
                    }}
                    handleSubmit={() => {
                        onImageMetaUpdate(index, this.state.imageMeta);
                        this.updateState();
                        if (this.state.cropRatioId) {
                            onImageCropRatioUpdate(
                                index,
                                this.state.cropRatioId
                            );
                        }
                    }}
                    handleCancel={() => {
                        this.updateState();
                    }}
                />

                <ImageDetailsCropDialog
                    cropResult={this.state.cropResult}
                    thumbCropResult={this.state.thumbCropResult}
                    imageToCrop={this.state.imageToCrop}
                    imageRatios={this.props.imageRatios}
                    open={this.state.openCropPopup}
                    imageMeta={this.state.imageMeta}
                    isHero={false}
                    setAltField={(alt) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                alt,
                            },
                        });
                    }}
                    setTitleField={(title) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                title,
                            },
                        });
                    }}
                    setDescriptionField={(description) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                description,
                            },
                        });
                    }}
                    setLinkField={(link) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                link,
                            },
                        });
                    }}
                    setNameField={(name) => {
                        this.setState({
                            imageMeta: {
                                ...this.state.imageMeta,
                                name,
                            },
                        });
                    }}
                    setCropResult={(cropResult) => {
                        this.setState({
                            cropResult,
                        });
                    }}
                    setThumbCropResult={(thumbCropResult) => {
                        this.setState({
                            thumbCropResult,
                        });
                    }}
                    setCropRatioId={(cropRatioId) => {
                        this.setState({
                            cropRatioId,
                        });
                    }}
                    handleSubmit={() => {
                        if (this.state.cropResult) {
                            let imageObject = b64toBlob(this.state.cropResult);
                            const imageUrlBlob = URL.createObjectURL(
                                imageObject
                            );
                            onCropImage(
                                index,
                                imageObject,
                                imageUrlBlob,
                                imageObject
                            );
                        }
                        if (this.state.thumbCropResult) {
                            let thumbImageObject = b64toBlob(
                                this.state.thumbCropResult
                            );
                            const imageThumbUrlBlob = URL.createObjectURL(
                                thumbImageObject
                            );
                            onCropThumbImage(
                                index,
                                thumbImageObject,
                                imageThumbUrlBlob,
                                thumbImageObject
                            );
                        }
                        if (this.state.cropRatioId) {
                            onImageCropRatioUpdate(
                                index,
                                this.state.cropRatioId
                            );
                        }
                        onImageMetaUpdate(index, this.state.imageMeta);
                        this.updateState();
                    }}
                    handleClose={() => {
                        this.updateState();
                    }}
                />
            </div>
        );
    }
}

export default withStyles(styles)(TextColumnsMultipleMediaSectionEdit);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/text_columns_multiple_media_section_edit.js